import React, { useEffect, useState, useContext } from "react";
import Grid from "@mui/material/Grid";
import Component from "./Component";


export const InteractiveDeck = (props) => {
    return (
        <div className="row py-5 justify-content-center">
            <div className="col-12">
                <p className="deck-title py-3">{props.deck.deckName}</p>
                <div className="d-flex justify-content-center">
                    {
                        props.deck.deckOptionals.map((myOptional, i) => (
                            <Component key={i} element={myOptional} callBack={props.callBack} enableConfiguration={true} deckName={props.deck.deckName} feedbackCallback={props.feedbackCallback} isProfile={props.deck.isProfile } />
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default InteractiveDeck;
